// Line icons, ported from design/files_v1.2/droog-admin/bundle.js (Icon, P):
// 24-grid, 1.75 stroke, round caps, drawn in currentColor. The first 34 are
// the design's verbatim; the ones after them are icons the admin needs that
// the design lacks (docs/design-inventory.md, Icon), drawn in the same style.
// Sizes from the design: 16 default, 14 in small buttons, 18 in alerts.

const ICON_PATHS = {
  dashboard: ['M4 13h6V4H4zM14 20h6v-9h-6zM14 8h6V4h-6zM4 20h6v-3H4z'],
  customers: [
    'M16 20v-1.5a3.5 3.5 0 0 0-3.5-3.5h-5A3.5 3.5 0 0 0 4 18.5V20',
    'M10 11.5a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5z',
    'M20 20v-1.5a3.5 3.5 0 0 0-2.5-3.35',
    'M15.5 5.2a3.25 3.25 0 0 1 0 6.1'
  ],
  invoice: ['M6 3h9l4 4v14H6z', 'M15 3v4h4', 'M9 12h7M9 16h7M9 8h3'],
  finance: ['M3 7h18v12H3z', 'M3 11h18', 'M7 15h3'],
  products: [
    'M12 3l8 4.5v9L12 21l-8-4.5v-9z',
    'M4 7.5l8 4.5 8-4.5',
    'M12 12v9'
  ],
  services: ['M4 5h16v5H4zM4 14h16v5H4z', 'M8 7.5h.01M8 16.5h.01'],
  domain: [
    'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z',
    'M3 12h18',
    'M12 3c2.5 2.6 3.7 5.6 3.7 9s-1.2 6.4-3.7 9c-2.5-2.6-3.7-5.6-3.7-9S9.5 5.6 12 3z'
  ],
  cluster: [
    'M12 3l3 1.7v3.6L12 10 9 8.3V4.7zM6 13l3 1.7v3.6L6 20l-3-1.7v-3.6zM18 13l3 1.7v3.6L18 20l-3-1.7v-3.6z'
  ],
  quote: ['M6 3h12v18H6z', 'M9 8h6M9 12h6M9 16h3'],
  settings: [
    'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
    'M19.4 13.5l1.6 1.2-2 3.4-1.9-.7a7 7 0 0 1-2 1.2L14.8 21h-4l-.3-2.4a7 7 0 0 1-2-1.2l-1.9.7-2-3.4 1.6-1.2a7 7 0 0 1 0-2.4L4.6 9.9l2-3.4 1.9.7a7 7 0 0 1 2-1.2L10.8 3h4l.3 2.4a7 7 0 0 1 2 1.2l1.9-.7 2 3.4-1.6 1.2a7 7 0 0 1 0 2.4z'
  ],
  search: ['M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14z', 'M20 20l-4-4'],
  plus: ['M12 5v14M5 12h14'],
  chevronRight: ['M9 6l6 6-6 6'],
  chevronLeft: ['M15 6l-6 6 6 6'],
  chevronDown: ['M6 9l6 6 6-6'],
  more: ['M5 12h.01M12 12h.01M19 12h.01'],
  download: ['M12 4v11M7 10l5 5 5-5', 'M5 20h14'],
  send: ['M21 3L10 14', 'M21 3l-7 18-4-7-7-4z'],
  mail: ['M3 5h18v14H3z', 'M3 6l9 7 9-7'],
  phone: [
    'M5 3h4l2 5-2.5 1.5a11 11 0 0 0 6 6L16 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 5a2 2 0 0 1 2-2z'
  ],
  edit: ['M4 20h4L19 9l-4-4L4 16z', 'M13.5 6.5l4 4'],
  filter: ['M4 5h16l-6 7.5V19l-4 1.5v-8z'],
  check: ['M5 12.5l4.5 4.5L19 7.5'],
  close: ['M6 6l12 12M18 6L6 18'],
  alert: ['M12 3l9.5 17h-19z', 'M12 10v4M12 17h.01'],
  info: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z', 'M12 11v5M12 8h.01'],
  clock: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z', 'M12 7v5l3 2'],
  external: ['M14 4h6v6', 'M20 4l-9 9', 'M18 14v6H4V6h6'],
  copy: ['M9 9h11v11H9z', 'M5 15H4V4h11v1'],
  credit: ['M6 3h9l4 4v14H6z', 'M9 13h7'],
  euro: ['M17 6.5A6.5 6.5 0 1 0 17 17.5', 'M5 10h8M5 14h8'],
  user: ['M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z', 'M5 20a7 7 0 0 1 14 0'],
  logout: ['M15 4h4v16h-4', 'M10 8l-4 4 4 4', 'M6 12h10'],
  sidebar: ['M4 4h16v16H4z', 'M9 4v16'],
  // Not in the design.
  sortAsc: ['M12 19V5', 'M7 10l5-5 5 5'],
  sortDesc: ['M12 5v14', 'M7 14l5 5 5-5'],
  trash: ['M4 7h16', 'M9 7V4h6v3', 'M6 7l1 13h10l1-13', 'M10 11v6M14 11v6'],
  refresh: [
    'M20 11a8 8 0 0 0-14.3-4.9L4 8',
    'M4 4v4h4',
    'M4 13a8 8 0 0 0 14.3 4.9L20 16',
    'M20 20v-4h-4'
  ],
  calendar: ['M4 5h16v15H4z', 'M4 10h16', 'M8 3v4M16 3v4'],
  play: ['M7 4.5l12 7.5-12 7.5z'],
  stop: ['M6 6h12v12H6z'],
  spinner: ['M12 3a9 9 0 1 0 9 9'],
  // A partial selection; the design draws a plus there.
  minus: ['M5 12h14']
} as const;

export type IconName = keyof typeof ICON_PATHS;

export const ICON_NAMES = Object.keys(ICON_PATHS) as IconName[];

interface IconProps {
  name: IconName;
  size?: number;
  strokeWidth?: number;
  /** Only for an icon that stands alone; otherwise it is decoration. */
  label?: string;
  className?: string;
}

export default function Icon({
  name,
  size = 16,
  strokeWidth = 1.75,
  label,
  className
}: IconProps): JSX.Element {
  const classes = ['inline-block', 'flex-none', 'align-middle'];
  if (name === 'spinner') classes.push('animate-spin');
  if (className !== undefined) classes.push(className);

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={classes.join(' ')}
      {...(label === undefined
        ? { 'aria-hidden': true }
        : { role: 'img', 'aria-label': label })}
    >
      {ICON_PATHS[name].map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}
